import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { auth, db, storage } from "./firebase";
import { collection, getDocs, doc, deleteDoc } from "firebase/firestore";
import { onAuthStateChanged } from "firebase/auth";
import { ref, deleteObject } from "firebase/storage";
import "./foto.css";

const Fotos = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [photos, setPhotos] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (authenticatedUser) => {
      if (authenticatedUser) {
        setUser(authenticatedUser);
      } else {
        setUser(null);
      }
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    const fetchPhotos = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "fotos"));
        const fetchedPhotos = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setPhotos(fetchedPhotos);
      } catch (err) {
        console.error("Error fetching photos:", err);
        setError("Error fetching photos. Please try again.");
      }
    };
    fetchPhotos();
  }, []);

  const handleDelete = async (photoId) => {
    if (window.confirm("Weet u zeker dat u deze foto wilt verwijderen?")) {
      try {
        const photoToDelete = photos.find((photo) => photo.id === photoId);

        await deleteDoc(doc(db, "fotos", photoId));

        if (photoToDelete?.images?.length) {
          for (const imagePathOrUrl of photoToDelete.images) {
            const storageRef = ref(storage, imagePathOrUrl);
            await deleteObject(storageRef);
          }
        }

        setPhotos((prev) => prev.filter((photo) => photo.id !== photoId));
      } catch (err) {
        console.error("Error deleting photo:", err);
        setError("Error deleting photo. Please try again.");
      }
    }
  };

  if (loading) return <p>Loading...</p>;
  if (error) return <p>{error}</p>;

  return (
    <section className="images-section">
      <h2>Recent werk</h2>
      {user && (
        <Link to="/upload" className="add-icon">
          <span>+</span>
        </Link>
      )}
      <div className="images-grid">
        {photos.length === 0 ? (
          <p>No photos uploaded yet.</p>
        ) : (
          photos.map((photo) => (
            <div key={photo.id} className="image-card">
          <Link to={`/fotos/${photo.id}`} className="image-link">
            <img
              src={photo.images?.[0] || "https://via.placeholder.com/150"}
              alt={photo.title}
              loading="lazy"
            />
            <h3>{photo.title}</h3>
            {photo.subDescription && (
              <p className="sub-description">{photo.subDescription}</p>
            )}
          </Link>

              {user && (
                <>
                  <button
                    className="delete-btn"
                    onClick={() => handleDelete(photo.id)}
                  >
                    Verwijder
                  </button>
                  <Link to={`/upload/${photo.id}`}>
                    <button className="edit-btn">Bewerk</button>
                  </Link>
                </>
              )}
            </div>
          ))
        )}
      </div>
    </section>
  );
};

export default Fotos;
